<div class="add-company-page">
  <div class="page-header">
    <h1>Add Company</h1>
  </div>

  <!-- Search Section -->
  <div class="search-section">
    <div class="search-bar">
      <input
        type="text"
        class="search-input"
        placeholder="Search Salesforce by AR Number or Company Name (min 3 characters)..."
        [value]="searchTerm"
        (input)="onSearchChange($event)" />
    </div>

    <!-- Loading indicator -->
    @if (salesforceLoading$ | async) {
      <div class="search-loading">
        <p>Searching Salesforce...</p>
      </div>
    }

    <!-- Search Results Grid -->
    @if (salesforceResults$ | async; as results) {
      @if (results.length > 0 && (salesforceLoading$ | async) === false) {
        <div class="search-results">
          <p class="results-count">
            Found {{ results.length }} companies in Salesforce
          </p>
          <table class="results-table">
            <thead>
              <tr>
                <th>AR Number</th>
                <th>Company Name</th>
                <th>Customer Type</th>
                <th>AR Status</th>
                <th>Phone</th>
              </tr>
            </thead>
            <tbody>
              @for (company of results; track company.arNumber) {
                <tr
                  (click)="onSelectCompany(company)"
                  (keydown.enter)="onSelectCompany(company)"
                  class="selectable-row">
                  <td>{{ company.arNumber }}</td>
                  <td>{{ company.companyName }}</td>
                  <td>{{ company.customerType || '-' }}</td>
                  <td>{{ company.arStatus || '-' }}</td>
                  <td>{{ company.phone || '-' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      <!-- No Results Message -->
      @if (
        results.length === 0 &&
        searchTerm.length >= 3 &&
        (salesforceLoading$ | async) === false
      ) {
        <div class="no-results">
          <p>
            No Salesforce companies found matching "{{ searchTerm }}". These
            companies may already exist in FPS or do not exist in Salesforce.
          </p>
        </div>
      }
    }

    <!-- Minimum length hint -->
    @if (searchTerm.length > 0 && searchTerm.length < 3) {
      <div class="search-hint-message">
        <p>Please enter at least 3 characters to search.</p>
      </div>
    }
  </div>

  <!-- Company Form -->
  <form [formGroup]="companyForm" class="company-form">
    <h2 class="form-section-header">Company Information</h2>
    <div class="form-section-body">
      <!-- Salesforce Readonly Fields -->
      <div class="readonly-fields-grid">
        <!-- AR Number -->
        <div class="form-field read-only">
          <span class="field-label" id="arNumberLabel">
            AR Number <span class="required">*</span>
          </span>
          <span class="field-value" aria-labelledby="arNumberLabel">
            {{ companyForm.get('arNumber')?.value || '—' }}
          </span>
          @if (arNumberControl?.invalid && arNumberControl?.touched) {
            <div class="field-error">
              @if (arNumberControl?.errors?.['required']) {
                <span>AR Number is required</span>
              }
            </div>
          }
        </div>

        <!-- Company Name -->
        <div class="form-field read-only">
          <span class="field-label" id="companyNameLabel">
            Company Name <span class="required">*</span>
          </span>
          <span class="field-value" aria-labelledby="companyNameLabel">
            {{ companyForm.get('name')?.value || '—' }}
          </span>
          @if (nameControl?.invalid && nameControl?.touched) {
            <div class="field-error">
              @if (nameControl?.errors?.['required']) {
                <span>Company Name is required</span>
              }
            </div>
          }
        </div>

        <!-- Customer Type -->
        <div class="form-field read-only">
          <span class="field-label" id="customerTypeLabel">Customer Type</span>
          <span class="field-value" aria-labelledby="customerTypeLabel">
            {{ selectedCustomerType || '—' }}
          </span>
        </div>

        <!-- Subprocessor Consent -->
        <div class="form-field read-only">
          <span class="field-label" id="subprocessorConsentLabel"
            >Subprocessor Consent</span
          >
          <span class="field-value" aria-labelledby="subprocessorConsentLabel">
            {{ selectedSubprocessorConsent || '—' }}
          </span>
        </div>
      </div>

      <!-- Shared Company Form Fields -->
      <app-company-form
        [companyForm]="companyForm"
        [printSites$]="printSites$"
        [customerTypes$]="customerTypes$"
        [saving$]="saving$"
        [saveError$]="saveError$"
        [showResetButton]="true"
        [hideCustomerType]="true"
        submitButtonText="Save"
        savingButtonText="Saving..."
        (save)="onSave()"
        (cancel)="onCancel()"
        (formReset)="onReset()">
      </app-company-form>
    </div>
  </form>
</div>
